





















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {InputVariableViewModel, StateViewModel} from '@/features/bots/models/designer';
import VariablePicker from './VariablePicker/VariablePicker.vue';
import IslandBadge from './IslandBadge.vue';
import {mixin as clickaway} from 'vue-clickaway';
import AdditionalInformationWrapper from './AdditionalInformationWrapper.vue';
import InputValidationConfig from './InputValidationConfig.vue';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import ChevronRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import TextEditor from '@/features/bots/components/designer/TextEditor/TextEditor.vue';
import {TransitionType} from '@/features/bots/models/designer/transitionType';
import {Getter} from 'vuex-class';
import { RegexType } from '../../models/designer/regexType';
@Component({
	mixins: [
		clickaway,
		validationMixin
	],
	components: {
		TextEditor,
		VariablePicker,
		IslandBadge,
		AdditionalInformationWrapper,
		InputValidationConfig,
		ChevronRight,
		ChevronLeft,
		ErrorIcon
	},
	validations: {
		state: {
			text: {
				required,
				attributeInvalid(value) {
					const inputStringComponent = (this as any);
					const invalidAttribute: boolean = inputStringComponent.invalidAttribute;
					return !invalidAttribute;
				}
			},
		},
		selectedVariable: {
			required,
			attributeMissing(value) {
				const inputStringComponent = (this as any); // Causes build error (fine in IDE) if we call this.? directly, work around
				const storedVar: InputVariableViewModel = inputStringComponent.state.storedVariable;
				return !storedVar || storedVar.scope !== 'appUser.customAttributes' || inputStringComponent.doesAttributeExist(storedVar.key);
			},
			attributeArchived(value) {
				const inputStringComponent = (this as any);
				return !inputStringComponent.isArchived();
			}
		}
	}
})
export default class InputStringComponent extends Vue {
	@Prop() public value: StateViewModel;
	@Getter public doesAttributeExist: (attributeId: string) => boolean;
	@Getter public isAttributeArchived!: (attributeId: string) => boolean;

	public $refs: {
		textEditor: TextEditor
	};

	public showConfig: boolean = false;
	public hasClicked: boolean = false;
	public transition: string = 'display';
	public invalidAttribute: boolean = false;
	public state: StateViewModel = {
		id: '',
		component: 'InputString'
	};

	public visibleFields: string[] = [];

	public selectedVariable = '';
	private additionalConfigInvalid = false;

	@Watch('value', { immediate: true })
	public onValueChanged(value: StateViewModel, previous: StateViewModel) {
		this.state = value;
		if (this.state.storedVariable) {
			this.selectedVariable = this.state.storedVariable.id;
		}
		this.updateValidation();
	}

	public mounted() {
		this.initialiseVisibleFields();
	}

	public setClickedState() {
		this.hasClicked = true;
	}

	public setUnclickedState() {
		this.hasClicked = false;
		this.showConfig = false;
		this.transition = 'display';

		this.$v.$touch();
	}

	public showExpandedConfig() {
		this.hasClicked = true;
		this.showConfig = true;
		this.transition = 'none';
	}

	public hideExpandedConfig() {
		this.showConfig = false;
	}

	public textUpdated(text: string) {
		if (this.state.text === text) {
			return;
		}

		this.state.text = text;

		this.updateValidation();
		if (this.$v.state && this.$v.state.text) {
			this.$v.state.text.$touch();
		}

		this.$emit('state-updated', this.state);
	}

	public initialiseVisibleFields() {
		if (this.isAppUserName()) {
			this.visibleFields = [];
		} else if (this.isAppUserEmail()) {
			this.visibleFields = ['errorMessage', 'allowedAttempts', 'noMatch'];
		} else if (this.isAppUserPhoneNumber()) {
			this.visibleFields = ['errorMessage', 'allowedAttempts', 'noMatch'];
		} else {
			this.visibleFields = ['errorMessage', 'pattern', 'allowedAttempts', 'noMatch'];
		}
	}

	public variableSelected(variable: InputVariableViewModel) {
		this.selectedVariable = variable.id;
		this.state.storedVariable = variable;

		if (this.isAppUserName()) {
			this.state.pattern = '';
			this.state.allowedAttempts = -1;
			this.state.errorMessage = '';
			this.state.noMatch = {type: TransitionType.Path, payload: ''};
			this.additionalConfigInvalid = false;
		} else if (this.isAppUserEmail()) {
			this.state.pattern = RegexType.EMAIL;
			this.state.allowedAttempts = -1;
			this.state.errorMessage = this.state.errorMessage && this.state.errorMessage.length ? this.state.errorMessage : 'That\'s not a valid email address, please try again.';
			this.state.noMatch = {type: TransitionType.Path, payload: ''};
			this.additionalConfigInvalid = false;
		} else if (this.isAppUserPhoneNumber()) {
			this.state.pattern = RegexType.PHONE_NUMBER;
			this.state.allowedAttempts = -1;
			this.state.errorMessage = this.state.errorMessage && this.state.errorMessage.length ? this.state.errorMessage : 'That\'s not a valid phone number, please try again.';
			this.state.noMatch = {type: TransitionType.Path, payload: ''};
			this.additionalConfigInvalid = false;
		} else if (this.state.storedVariable.dataType === 'number') {
			this.state.pattern = RegexType.NUMERIC;
			this.state.allowedAttempts = -1;
			this.state.errorMessage = this.state.errorMessage && this.state.errorMessage.length ? this.state.errorMessage : 'That\'s not a valid number, please try again.';
			this.state.noMatch = {type: TransitionType.Path, payload: ''};
			this.additionalConfigInvalid = false;
		}  else if (this.state.storedVariable.dataType === 'decimal') {
			this.state.pattern = RegexType.DECIMAL;
			this.state.allowedAttempts = -1;
			this.state.errorMessage = this.state.errorMessage && this.state.errorMessage.length ? this.state.errorMessage : 'That\'s not a valid decimal, please try again.';
			this.state.noMatch = {type: TransitionType.Path, payload: ''};
			this.additionalConfigInvalid = false;
		} else {
			this.state.pattern = '';
			this.state.allowedAttempts = -1;
			this.state.errorMessage = this.state.errorMessage && this.state.errorMessage.length ? this.state.errorMessage : '';
			this.state.noMatch = this.state.noMatch && this.state.noMatch.payload ? this.state.noMatch : {type: TransitionType.Path, payload: ''};
		}

		this.initialiseVisibleFields();
		if (this.$v.state && this.$v.state.storedVariable) {
			this.$v.state.storedVariable.$touch();
		}
		this.updateValidation();

		this.$emit('state-updated', this.state);
	}

	public additionalConfigChanged(update: any) {
		this.state = update.state;
		this.additionalConfigInvalid = update.invalid;
		this.updateValidation();
		this.$emit('state-updated', this.state);
	}

	public isArchived(): boolean {
		if (this.state && this.state.storedVariable) {
			return this.isAttributeArchived(this.state.storedVariable!.key);
		}
		return false;
	}

	public setInvalidAttribute(val: boolean) {
		this.invalidAttribute = val;
		this.$v.$touch();
		this.state.invalid = this.$v.$invalid;
	}

	public focusOnInput() {
		this.$refs.textEditor.focusElement();
		this.$refs.textEditor.startEditing();
	}

	private isAppUserName() {
		return this.state.storedVariable && this.state.storedVariable.scope === 'appUser' && this.state.storedVariable.key === 'name';
	}

	private isAppUserEmail() {
		return this.state.storedVariable && this.state.storedVariable.scope === 'appUser' && this.state.storedVariable.key === 'email';
	}

	private isAppUserPhoneNumber() {
		return this.state.storedVariable && this.state.storedVariable.scope === 'appUser' && this.state.storedVariable.key === 'phoneNumber';
	}

	private updateValidation() {
		this.state.invalid = this.additionalConfigInvalid || this.$v.$invalid;
	}
}
